// Contract addresses - Updated for SWM deposit flow integration
export const swmAddress = '0x07aea508E43bC410417F8ad39c6Ae19BF717a93d'; // SWM token
export const wethAddress = '0x5fd7023CeB1EE73ab1a6f50233Db54695b7F0fC5'; // WETH
export const llmnftAddress = '0x0246C0e0bCDA87b7B39e1D4FEf71B326FB56aaA9'; // LLMNFT (09.12.2025)
export const hfswmAddress = '0x44707Ff897249224a733CcA6133Fe2F3B5055633'; // HFSWM
export const poolAddress = '0x63f94F98809b94d26e50C64f233d34ef38f79aDC'; // Pool (09.12.2025)
export const walletHubAddress = '0x848624851ade3e984993E4805fD36Bca84CE1C0A'; // WalletHub (09.12.2025)

// Legacy addresses (keeping for backward compatibility)
export const usdtAddress = '0xee09EA2B9CF153e9387b7070Ef270e4e94788d1d';
export const credAddress = usdtAddress; // CRED token (alias for USDT)
export const receiverAddress = '0xE76b4773227Fb82e9759c276EFA83E5547deAEaD'; // Myrs's address for tests

// Token configurations
export const SWM_CONFIG = {
  address: swmAddress,
  decimals: 9,
  symbol: 'SWM',
  name: 'Swarm Token',
  permitSupported: true,
} as const;

export const TOKEN_CONFIGS = {
  SWM: SWM_CONFIG,
  CRED: {
    address: credAddress,
    decimals: 18,
    symbol: 'CRED',
    name: 'Credit Token',
    permitSupported: false,
  },
  WETH: {
    address: wethAddress,
    decimals: 18,
    symbol: 'WETH',
    name: 'Wrapped Ethereum',
    permitSupported: false,
  },
  HFSWM: {
    address: hfswmAddress,
    decimals: 18,
    symbol: 'HFSWM',
    name: 'HFSWM Token',
    permitSupported: false,
  },
} as const;

// Network configuration
export const SWARM_DEVNET_CONFIG = {
  chainId: '0x142f55', // 1322837 in hex
  chainName: 'Swarm',
  rpcUrls: ['wss://ws.devnet.swarmind.ai'],
  blockExplorerUrls: ['https://explorer.devnet.swarmind.ai/'],
  nativeCurrency: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
  },
} as const;

// Base mainnet
export const BASE_CONFIG = {
  chainId: '0x2105', // 8453
  chainName: 'Base',
  rpcUrls: ['https://mainnet.base.org'],
  blockExplorerUrls: ['https://basescan.org/'],
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
  },
} as const;

// Legacy exports for backward compatibility
export const permitDeadlineSeconds = 3000;
export const chainId = SWARM_DEVNET_CONFIG.chainId;
export const chainName = SWARM_DEVNET_CONFIG.chainName;
export const curName = SWARM_DEVNET_CONFIG.nativeCurrency.name;
export const curSymbol = SWARM_DEVNET_CONFIG.nativeCurrency.symbol;
export const curDec = SWARM_DEVNET_CONFIG.nativeCurrency.decimals;
export const chainRPC = SWARM_DEVNET_CONFIG.rpcUrls[0];
export const blockExplorer = SWARM_DEVNET_CONFIG.blockExplorerUrls[0];

// Pool contract configuration
export const POOL_CONFIG = {
  address: poolAddress,
  functions: {
    getModel: 'GetModel(uint256)',
    preRequest: 'Pre_request(uint256,address)',
  },
  events: {
    modelAdded: 'ModelAdded(...)',
  },
} as const;

// WalletHub contract configuration
export const WALLET_HUB_CONFIG = {
  address: walletHubAddress,
  functions: {
    deposit: 'deposit(uint256)',
    userBalance: 'userBalance(address)',
  },
  events: {
    deposit: 'Deposit(address,uint256)',
  },
} as const;

// Bridge addresses 
export const BRIDGE_ADDRESSES = {
  CUSTOM_1322837: '0x521984F2fF6dEc08d9842c62E391D4E74f7BB613', // BridgeCustomNetwork
  BASE_8453: '0x6FC192a75E234DE464456c96C69565E5abE46df4', // BridgeBaseNetwork
} as const;

// Bridge token addresses per chain
export const BRIDGE_TOKENS = {
  BASE: {
    SWM: '0x5fd7023CeB1EE73ab1a6f50233Db54695b7F0fC5',
    USDC: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
  },
  CUSTOM: {
    SWM: '0x07aea508E43bC410417F8ad39c6Ae19BF717a93d',
    WETH: '0x5fd7023CeB1EE73ab1a6f50233Db54695b7F0fC5',
    CREDIT: '0x07aea508E43bC410417F8ad39c6Ae19BF717a93d',
  },
} as const;

// Bridge fee configuration
export const BRIDGE_FEE_MODE: 'onchain' | 'fallback' = 'onchain';
// Fallback fee in basis points (e.g., 50 = 0.50%) if on-chain fee cannot be read
export const BRIDGE_FALLBACK_FEE_BPS = 50;

// Development mode configuration
export const DEVELOPMENT_CONFIG = {
  enableLocalNetworks: process.env.NODE_ENV === 'development',
  enableDebugLogging: process.env.NODE_ENV === 'development',
  contractValidationEnabled: true,
} as const;
